module.exports = __webpack_public_path__ + "static/media/md-color-fill.280e2ce1.svg";